export const sugars = [
    {
        abbreviation: '4eLeg',
        shortName: '4-epi-Legionaminic acid',
        iupacCondensed: 'b-4eLeg-onic',
        smiles: 'C[C@H]([C@H]([C@H]1[C@@H]([C@@H](C[C@](O1)(C(=O)O)O)O)N)N)O',
        idCode: 'fhqPp@CV@`eM^rJZQYQIRpTfjjjjjYa\\PeJJSd@',
    },
    {
        abbreviation: '6dAlt',
        shortName: '6-Deoxy-L-altrose',
        iupacCondensed: '6-deoxy-Alt',
        smiles: 'C[C@H]1[C@@H]([C@@H]([C@H](C(O1)O)O)O)O',
        idCode: 'dmtJ@@siWIEEMDZFjjjbQDj`h@',
    },
    {
        abbreviation: '6dAltNAc',
        shortName: 'N-Acetyl-6-deoxy-L-altrosamine',
        iupacCondensed: '6-deoxy-AltNAc',
        smiles: 'C[C@H]1[C@@H]([C@@H]([C@H](C(O1)O)NC(=O)C)O)O',
        idCode: 'dg^J@DCad|bbtTTQRzuUUUQEFbkT@',
    },
    {
        abbreviation: '6dGul',
        shortName: '6-Deoxy-D-gulose',
        iupacCondensed: '6-deoxy-Gul',
        smiles: 'C[C@@H]1[C@@H]([C@H]([C@H](C(O1)O)O)O)O',
        idCode: 'dmtJ@@siWIEEMDZFjjjbRDj`p@',
    },
    {
        abbreviation: '6dTal',
        shortName: '6-Deoxy-D-talose',
        iupacCondensed: '6-deoxy-Tal',
        smiles: 'C[C@@H]1[C@@H]([C@@H]([C@@H](C(O1)O)O)O)O',
        idCode: 'dmtJ@@siWIEEMDZFjjjbREJ`h@',
    },
    {
        abbreviation: '6dTalNAc',
        shortName: 'N-Acetyl-6-deoxy-D-talosamine',
        iupacCondensed: '6-deoxy-TalNAc',
        smiles: 'C[C@@H]1[C@@H]([C@@H]([C@@H](C(O1)O)NC(=O)C)O)O',
        idCode: 'dg^J@DCad|bbtTTQRzuUUUQDfbkX@',
    },
    {
        abbreviation: '8eAci',
        shortName: '8-epi-Acinetaminic acid',
        iupacCondensed: '3,9-deoxy-D-gro-a-L-altNon2ulo5N7N-onic',
        smiles: 'C[C@H]([C@@H]([C@H]1[C@@H]([C@H](C[C@](O1)(C(=O)O)O)O)N)N)O',
        idCode: 'fhqPp@CV@`eM^rJZQYQIRpTfjjjjjYa\\PiJJcd@',
    },
    {
        abbreviation: '8eLeg',
        shortName: '8-epi-Legionaminic acid',
        iupacCondensed: '3,9-deoxy-L-gro-b-D-galNon2ulo5N7N-onic',
        smiles: 'C[C@@H]([C@H]([C@H]1[C@@H]([C@H](C[C@](O1)(C(=O)O)O)O)N)N)O',
        idCode: 'fhqPp@CV@`eM^rJZQYQIRpTfjjjjjYa\\PiJJSh@',
    },
    {
        abbreviation: 'Abe',
        shortName: 'Abequose',
        iupacCondensed: 'Abe',
        smiles: 'C[C@@H]1[C@@H](C[C@H](C(O1)O)O)O',
        idCode: 'deTB@@siRf[fajjjlRDj`@',
    },
    {
        abbreviation: 'Aci',
        shortName: 'Acinetaminic acid',
        iupacCondensed: 'a-Aci-onic',
        smiles: 'C[C@@H]([C@@H]([C@H]1[C@@H]([C@H](C[C@](O1)(C(=O)O)O)O)N)N)O',
        idCode: 'fhqPp@CV@`eM^rJZQYQIRpTfjjjjjYa\\PiJJch@',
    },
    {
        abbreviation: 'All',
        shortName: 'D-Allose',
        iupacCondensed: 'All',
        smiles: 'C([C@@H]1[C@H]([C@H]([C@H](C(O1)O)O)O)O)O',
        idCode: 'dcLF@@siWTify^ajjjjIHRiC@@',
    },
    {
        abbreviation: 'AllA',
        shortName: 'D-Alluronic acid',
        iupacCondensed: 'AllA',
        smiles: '[C@H]1([C@@H]([C@H](OC([C@@H]1O)O)C(=O)O)O)O',
        idCode: 'dklN@@PngSR[ef|UZjjjbrUARp@',
    },
    {
        abbreviation: 'AllN',
        shortName: 'D-Allosamine',
        iupacCondensed: 'AllN',
        smiles: 'C([C@@H]1[C@H]([C@H]([C@H](C(O1)O)N)O)O)O',
        idCode: 'dcNJ@NCIWTify^ajjjjIHRiC@@',
    },
    {
        abbreviation: 'AllNAc',
        shortName: 'N-Acetyl-D-allosamine',
        iupacCondensed: 'AllNAc',
        smiles: 'CC(=O)N[C@@H]1[C@@H]([C@@H]([C@H](OC1O)CO)O)O',
        idCode: 'do~F@DCadwrJKQQQEY]ZjjjjHhrV[@@',
    },
    {
        abbreviation: 'Alt',
        shortName: 'L-Altrose',
        iupacCondensed: 'Alt',
        smiles: 'C([C@H]1[C@@H]([C@@H]([C@H](C(O1)O)O)O)O)O',
        idCode: 'dcLF@@siWTify^ajjjjIDRjB`@',
    },
    {
        abbreviation: 'AltA',
        shortName: 'L-Altruronic acid',
        iupacCondensed: 'AltA',
        smiles: '[C@@H]1([C@H]([C@@H](OC([C@@H]1O)O)C(=O)O)O)O',
        idCode: 'dklN@@PngSR[ef|UZjjjbqTabp@',
    },
    {
        abbreviation: 'AltN',
        shortName: 'L-Altrosamine',
        iupacCondensed: 'AltN',
        smiles: 'C([C@H]1[C@@H]([C@@H]([C@H](C(O1)O)N)O)O)O',
        idCode: 'dcNJ@NCIWTify^ajjjjIDRjB`@',
    },
    {
        abbreviation: 'AltNAc',
        shortName: 'N-Acetyl-L-altrosamine',
        iupacCondensed: 'AltNAc',
        smiles: 'CC(=O)N[C@@H]1[C@H]([C@H]([C@@H](OC1O)CO)O)O',
        idCode: 'do~F@DCadwrJKQQQEY]ZjjjjHhtUZ`@',
    },
    {
        abbreviation: 'Api',
        shortName: 'L-Apiose',
        iupacCondensed: '(3R,4R)-4-(hydroxymethyl)oxolane-2,3,4-triol',
        smiles: 'C1[C@@]([C@H](C(O1)O)O)(CO)O',
        idCode: 'deTJ@@qngIEEeBUUUUREJP@',
    },
    {
        abbreviation: 'Ara',
        shortName: 'L-Arabinose',
        iupacCondensed: 'Ara',
        smiles: 'C1[C@@H]([C@@H]([C@H](C(O1)O)O)O)O',
        idCode: 'deTJ@@qaeJYyzzjjjpeTy@@',
    },
    {
        abbreviation: 'Bac',
        shortName: 'Bacillosamine',
        iupacCondensed: 'Bac',
        smiles: 'C[C@@H]1[C@H]([C@@H]([C@H](C(O1)O)N)O)N',
        idCode: 'dmuL@NdLWIEEMDZFjjjbRDjPh@',
    },
    {
        abbreviation: 'Col',
        shortName: 'Colitose',
        iupacCondensed: 'Col',
        smiles: 'C[C@H]1[C@H](C[C@@H](C(O1)O)O)O',
        idCode: 'deTB@@siRf[fajjjlQEJP@',
    },
    {
        abbreviation: 'DDmanHep',
        shortName: 'D-glycero-D-manno-Heptose',
        iupacCondensed: 'DDManHep',
        smiles: 'C([C@H]([C@@H]1[C@H]([C@@H]([C@@H](C(O1)O)O)O)O)O)O',
        idCode: String.raw `dg\N@@siT{rQQSQJXtMUUUUTdJTfPh@`,
    },
    {
        abbreviation: 'Dha',
        shortName: '3-Deoxy-D-lyxo-heptulosaric acid',
        iupacCondensed: '(4R,5R,6S)-2,4,5-trihydroxyoxane-2,6-dicarboxylic acid',
        smiles: 'C1[C@H]([C@H]([C@H](OC1(C(=O)O)O)C(=O)O)O)O',
        idCode: 'do|A@@Pjt{]IngYYEVjjjZlyBe`@',
    },
    {
        abbreviation: 'Dig',
        shortName: 'D-Digitoxose',
        iupacCondensed: 'Dig',
        smiles: 'C[C@@H]1[C@H]([C@H](CC(O1)O)O)O',
        idCode: 'deTB@@pYRf[^njjjlRTn`@',
    },
    {
        abbreviation: 'Fru',
        shortName: 'D-Fructose',
        iupacCondensed: 'Fru',
        smiles: 'C1[C@H]([C@H]([C@@H](C(O1)(CO)O)O)O)O',
        idCode: 'dcLF@@siWTiiy]ajjjjphrF@@',
    },
    {
        abbreviation: 'Fuc',
        shortName: 'L-Fucose',
        iupacCondensed: 'Fuc',
        smiles: 'C[C@H]1[C@H]([C@H]([C@@H](C(O1)O)O)O)O',
        idCode: 'dmtJ@@siWIEEMDZFjjjbQEJPp@',
    },
    {
        abbreviation: 'FucNAc',
        shortName: 'N-Acetyl-L-fucosamine',
        iupacCondensed: 'FucNAc',
        smiles: 'C[C@H]1[C@H]([C@H]([C@@H](C(O1)O)NC(=O)C)O)O',
        idCode: 'dg^J@DCad|bbtTTQRzuUUUQDfRsT@',
    },
    {
        abbreviation: 'Gal',
        shortName: 'D-Galactose',
        iupacCondensed: 'Gal',
        smiles: 'C([C@@H]1[C@@H]([C@@H]([C@H](C(O1)O)O)O)O)O',
        idCode: 'dcLF@@siWTify^ajjjjIHRjB`@',
    },
    {
        abbreviation: 'GalA',
        shortName: 'D-Galacturonic acid',
        iupacCondensed: 'GalA',
        smiles: '[C@@H]1([C@H]([C@H](OC([C@@H]1O)O)C(=O)O)O)O',
        idCode: 'dklN@@PngSR[ef|UZjjjbrTabp@',
    },
    {
        abbreviation: 'GalN',
        shortName: 'D-Galactosamine',
        iupacCondensed: 'GalN',
        smiles: 'C([C@@H]1[C@@H]([C@@H]([C@H](C(O1)O)N)O)O)O',
        idCode: 'dcNJ@NCIWTify^ajjjjIHRjB`@',
    },
    {
        abbreviation: 'GalNAc',
        shortName: 'N-Acetyl-D-galactosamine',
        iupacCondensed: 'GalNAc',
        smiles: 'CC(=O)N[C@@H]1[C@H]([C@H]([C@H](OC1O)CO)O)O',
        idCode: 'do~F@DCadwrJKQQQEY]ZjjjjHhtU[@@',
    },
    {
        abbreviation: 'Glc',
        shortName: 'D-Glucose',
        iupacCondensed: 'Glc',
        smiles: 'C([C@@H]1[C@H]([C@@H]([C@H](C(O1)O)O)O)O)O',
        idCode: 'dcLF@@siWTify^ajjjjIHRiB`@',
    },
    {
        abbreviation: 'GlcA',
        shortName: 'D-Glucuronic acid',
        iupacCondensed: 'GlcA',
        smiles: '[C@@H]1([C@@H]([C@H](OC([C@@H]1O)O)C(=O)O)O)O',
        idCode: 'dklN@@PngSR[ef|UZjjjbrUAbp@',
    },
    {
        abbreviation: 'GlcN',
        shortName: 'D-Glucosamine',
        iupacCondensed: 'GlcN',
        smiles: 'C([C@@H]1[C@H]([C@@H]([C@H](C(O1)O)N)O)O)O',
        idCode: 'dcNJ@NCIWTify^ajjjjIHRiB`@',
    },
    {
        abbreviation: 'GlcNAc',
        shortName: 'N-Acetyl-D-glucosamine',
        iupacCondensed: 'GlcNAc',
        smiles: 'CC(=O)N[C@@H]1[C@H]([C@@H]([C@H](OC1O)CO)O)O',
        idCode: 'do~F@DCadwrJKQQQEY]ZjjjjHhtV[@@',
    },
    {
        abbreviation: 'Gul',
        shortName: 'D-Gulose',
        iupacCondensed: 'Gul',
        smiles: 'C([C@@H]1[C@@H]([C@H]([C@H](C(O1)O)O)O)O)O',
        idCode: 'dcLF@@siWTify^ajjjjIHRjC@@',
    },
    {
        abbreviation: 'GulA',
        shortName: 'D-Guluronic acid',
        iupacCondensed: 'GulA',
        smiles: '[C@H]1([C@H]([C@H](OC([C@@H]1O)O)C(=O)O)O)O',
        idCode: 'dklN@@PngSR[ef|UZjjjbrTaRp@',
    },
    {
        abbreviation: 'GulN',
        shortName: 'D-Gulosamine',
        iupacCondensed: 'GulN',
        smiles: 'C([C@@H]1[C@@H]([C@H]([C@H](C(O1)O)N)O)O)O',
        idCode: 'dcNJ@NCIWTify^ajjjjIHRjC@@',
    },
    {
        abbreviation: 'GulNAc',
        shortName: 'N-Acetyl-D-gulosamine',
        iupacCondensed: 'GulNAc',
        smiles: 'CC(=O)N[C@@H]1[C@@H]([C@H]([C@H](OC1O)CO)O)O',
        idCode: 'do~F@DCadwrJKQQQEY]ZjjjjHhrU[@@',
    },
    {
        abbreviation: 'Ido',
        shortName: 'L-Idose',
        iupacCondensed: 'Ido',
        smiles: 'C([C@H]1[C@H]([C@@H]([C@H](C(O1)O)O)O)O)O',
        idCode: 'dcLF@@siWTify^ajjjjIDRiB`@',
    },
    {
        abbreviation: 'IdoA',
        shortName: 'L-Iduronic acid',
        iupacCondensed: 'IdoA',
        smiles: '[C@@H]1([C@@H]([C@@H](OC([C@@H]1O)O)C(=O)O)O)O',
        idCode: 'dklN@@PngSR[ef|UZjjjbqUAbp@',
    },
    {
        abbreviation: 'IdoN',
        shortName: 'L-Idosamine',
        iupacCondensed: 'IdoN',
        smiles: 'C([C@H]1[C@H]([C@@H]([C@H](C(O1)O)N)O)O)O',
        idCode: 'dcNJ@NCIWTify^ajjjjIDRiB`@',
    },
    {
        abbreviation: 'IdoNAc',
        shortName: 'N-Acetyl-L-idosamine',
        iupacCondensed: 'IdoNAc',
        smiles: 'CC(=O)N[C@@H]1[C@H]([C@@H]([C@@H](OC1O)CO)O)O',
        idCode: 'do~F@DCadwrJKQQQEY]ZjjjjHhtVZ`@',
    },
    {
        abbreviation: 'Kdn',
        shortName: '2-Keto-3-deoxy-nononic acid',
        iupacCondensed: 'Kdn',
        smiles: 'C1[C@@H]([C@H]([C@@H](OC1(C(=O)O)O)[C@@H]([C@@H](CO)O)O)O)O',
        idCode: 'fdiAH@@HISQk^cdTtbrbRefEIjjjjjjgDJRbdy@@',
    },
    {
        abbreviation: 'Kdo',
        shortName: '3-Deoxy-D-manno-octulosonic acid',
        iupacCondensed: 'Kdo',
        smiles: 'C1[C@H]([C@H]([C@H](OC1(C(=O)O)O)[C@@H](CO)O)O)O',
        idCode: 'f`a@H@@HISQk^rJZQYQIRbduUUUUDyAJTT`@',
    },
    {
        abbreviation: 'Leg',
        shortName: 'Legionaminic acid',
        iupacCondensed: 'b-Leg-onic',
        smiles: 'C[C@H]([C@H]([C@H]1[C@@H]([C@H](C[C@](O1)(C(=O)O)O)O)N)N)O',
        idCode: 'fhqPp@CV@`eM^rJZQYQIRpTfjjjjjYa\\PiJJSd@',
    },
    {
        abbreviation: 'LDmanHep',
        shortName: 'L-glycero-D-manno-Heptose',
        iupacCondensed: 'LDManHep',
        smiles: 'C([C@@H]([C@@H]1[C@H]([C@@H]([C@@H](C(O1)O)O)O)O)O)O',
        idCode: 'dg\\N@@siT{rQQSQJXtMUUUUTdJTf`h@',
    },
    {
        abbreviation: 'Lyx',
        shortName: 'D-Lyxose',
        iupacCondensed: 'Lyx',
        smiles: 'C1[C@H]([C@@H]([C@@H](C(O1)O)O)O)O',
        idCode: 'deTJ@@qaeJYyzzjjjpiRy@@',
    },
    {
        abbreviation: 'Man',
        shortName: 'D-Mannose',
        iupacCondensed: 'Man',
        smiles: 'C([C@@H]1[C@H]([C@@H]([C@@H](C(O1)O)O)O)O)O',
        idCode: 'dcLF@@siWTify^ajjjjIHTiB`@',
    },
    {
        abbreviation: 'ManA',
        shortName: 'D-Mannuronic acid',
        iupacCondensed: 'ManA',
        smiles: '[C@@H]1([C@@H]([C@H](OC([C@H]1O)O)C(=O)O)O)O',
        idCode: 'dklN@@PngSR[ef|UZjjjbrUAbh@',
    },
    {
        abbreviation: 'ManN',
        shortName: 'D-Mannosamine',
        iupacCondensed: 'ManN',
        smiles: 'C([C@@H]1[C@H]([C@@H]([C@@H](C(O1)O)N)O)O)O',
        idCode: 'dcNJ@NCIWTify^ajjjjIHTiB`@',
    },
    {
        abbreviation: 'ManNAc',
        shortName: 'N-Acetyl-D-mannosamine',
        iupacCondensed: 'ManNAc',
        smiles: 'CC(=O)N[C@H]1[C@H]([C@@H]([C@H](OC1O)CO)O)O',
        idCode: 'do~F@DCadwrJKQQQEY]ZjjjjHdtV[@@',
    },
    {
        abbreviation: 'Mur',
        shortName: 'Muramic acid',
        iupacCondensed: 'Mur',
        smiles: 'C[C@H](C(=O)O)O[C@H]1[C@@H]([C@H](OC([C@@H]1N)O)CO)O',
        idCode: 'fhqap@M@PRUoAR[gf[oMYjjjjjjXSIqBbd@',
    },
    {
        abbreviation: 'MurNAc',
        shortName: 'N-Acetylmuramic acid',
        iupacCondensed: 'MurNAc',
        smiles: 'C[C@H](C(=O)O)O[C@H]1[C@@H]([C@H](OC([C@@H]1NC(=O)C)O)CO)O',
        idCode: 'fbe`H@M@PRU`qRdwOLwKlZsUUUUUMTpfSbEEH@',
    },
    {
        abbreviation: 'MurNGc',
        shortName: 'N-Glycolylmuramic acid',
        iupacCondensed: 'MurNGc',
        smiles: 'C[C@H](C(=O)O)O[C@H]1[C@@H]([C@H](OC([C@@H]1NC(=O)CO)O)CO)O',
        idCode: 'fjuaH@M@PRU`qRWHihmEEMDliSVZjjjjijiaLgDJJP@',
    },
    {
        abbreviation: 'Neu',
        shortName: 'Neuraminic acid',
        iupacCondensed: 'Neu',
        smiles: 'C1[C@@H]([C@H]([C@@H](OC1(C(=O)O)O)[C@@H]([C@@H](CO)O)O)N)O',
        idCode: 'fdi`H@C@PRfk^cdTtbrbRefEIjjjjjjgDJRbdy@@',
    },
    {
        abbreviation: 'Neu5Ac',
        shortName: 'N-Acetylneuraminic acid',
        iupacCondensed: 'NeuAc',
        smiles: 'CC(=O)N[C@@H]1[C@H](CC(O[C@H]1[C@@H]([C@@H](CO)O)O)(C(=O)O)O)O',
        idCode: 'fjuaH@C@PRfkARUIngYV~[EIjjjjjfjgDJRbdy@@',
    },
    {
        abbreviation: 'Neu5Gc',
        shortName: 'N-Glycolylneuraminic acid',
        iupacCondensed: 'NeuGc',
        smiles: 'C1[C@@H]([C@H]([C@@H](OC1(C(=O)O)O)[C@@H]([C@@H](CO)O)O)NC(=O)CO)O',
        idCode: 'ffm`h@C@PRfkARVjS]Nrm|wbduUUUUSUTxaRTTgH@',
    },
    {
        abbreviation: 'Oli',
        shortName: 'Olivose',
        iupacCondensed: 'Oli',
        smiles: 'C[C@@H]1[C@H]([C@@H](CC(O1)O)O)O',
        idCode: 'deTB@@pYRf[^njjjlRTnP@',
    },
    {
        abbreviation: 'Par',
        shortName: 'Paratose',
        iupacCondensed: 'Par',
        smiles: 'C[C@@H]1[C@H](C[C@H](C(O1)O)O)O',
        idCode: 'deTB@@siRf[fajjjlRDjP@',
    },
    {
        abbreviation: 'Pse',
        shortName: 'Pseudaminic acid',
        iupacCondensed: 'a-Pse-onic',
        smiles: 'C[C@@H]([C@@H]([C@H]1[C@H]([C@H](C[C@](O1)(C(=O)O)O)O)N)N)O',
        idCode: 'fhqPp@CV@`eM^rJZQYQIRpTfjjjjjYa\\PiIJch@',
    },
    {
        abbreviation: 'Psi',
        shortName: 'D-Psicose',
        iupacCondensed: 'Psi',
        smiles: 'C1[C@H]([C@H]([C@H](C(O1)(CO)O)O)O)O',
        idCode: 'dcLF@@siWTiiy]ajjjjpdrF@@',
    },
    {
        abbreviation: 'Qui',
        shortName: 'D-Quinovose',
        iupacCondensed: 'Qui',
        smiles: 'C[C@@H]1[C@H]([C@@H]([C@H](C(O1)O)O)O)O',
        idCode: 'dmtJ@@siWIEEMDZFjjjbRDjPh@',
    },
    {
        abbreviation: 'QuiNAc',
        shortName: 'N-Acetyl-D-quinovosamine',
        iupacCondensed: 'QuiNAc',
        smiles: 'C[C@@H]1[C@H]([C@@H]([C@H](C(O1)O)NC(=O)C)O)O',
        idCode: 'dg^J@DCad|bbtTTQRzuUUUQEFbsX@',
    },
    {
        abbreviation: 'Rha',
        shortName: 'L-Rhamnose',
        iupacCondensed: 'Rha',
        smiles: 'C[C@H]1[C@@H]([C@H]([C@H](C(O1)O)O)O)O',
        idCode: 'dmtJ@@siWIEEMDZFjjjbQDj`p@',
    },
    {
        abbreviation: 'RhaNAc',
        shortName: 'N-Acetyl-L-rhamnosamine',
        iupacCondensed: 'RhaNAc',
        smiles: 'C[C@H]1[C@@H]([C@H]([C@H](C(O1)O)NC(=O)C)O)O',
        idCode: 'dg^J@DCad|bbtTTQRzuUUUQEFRkT@',
    },
    {
        abbreviation: 'Rib',
        shortName: 'D-Ribose',
        iupacCondensed: 'Rib',
        smiles: 'C1[C@H]([C@H]([C@H](C(O1)O)O)O)O',
        idCode: 'deTJ@@qaeJYyzzjjjpeRz@@',
    },
    {
        abbreviation: 'Sor',
        shortName: 'L-Sorbose',
        iupacCondensed: 'Sor',
        smiles: 'C1[C@@H]([C@H]([C@@H](C(O1)(CO)O)O)O)O',
        idCode: 'dcLF@@siWTiiy]ajjjjphtF@@',
    },
    {
        abbreviation: 'Tag',
        shortName: 'D-Tagatose',
        iupacCondensed: 'Tag',
        smiles: 'C1[C@H]([C@@H]([C@@H](C(O1)(CO)O)O)O)O',
        idCode: 'dcLF@@siWTiiy]ajjjjphrE@@',
    },
    {
        abbreviation: 'Tal',
        shortName: 'D-Talose',
        iupacCondensed: 'Tal',
        smiles: 'C([C@@H]1[C@@H]([C@@H]([C@@H](C(O1)O)O)O)O)O',
        idCode: 'dcLF@@siWTify^ajjjjIHTjB`@',
    },
    {
        abbreviation: 'TalA',
        shortName: 'D-Taluronic acid',
        iupacCondensed: 'TalA',
        smiles: '[C@@H]1([C@H]([C@H](OC([C@H]1O)O)C(=O)O)O)O',
        idCode: 'dklN@@PngSR[ef|UZjjjbrTabh@',
    },
    {
        abbreviation: 'TalN',
        shortName: 'D-Talosamine',
        iupacCondensed: 'TalN',
        smiles: 'C([C@@H]1[C@@H]([C@@H]([C@@H](C(O1)O)N)O)O)O',
        idCode: 'dcNJ@NCIWTify^ajjjjIHTjB`@',
    },
    {
        abbreviation: 'TalNAc',
        shortName: 'N-Acetyl-D-talosamine',
        iupacCondensed: 'TalNAc',
        smiles: 'CC(=O)N[C@H]1[C@H]([C@H]([C@H](OC1O)CO)O)O',
        idCode: 'do~F@DCadwrJKQQQEY]ZjjjjHdtU[@@',
    },
    {
        abbreviation: 'Tyv',
        shortName: 'Tyvelose',
        iupacCondensed: 'Tyv',
        smiles: 'C[C@@H]1[C@H](C[C@@H](C(O1)O)O)O',
        idCode: 'deTB@@siRf[fajjjlREJP@',
    },
    {
        abbreviation: 'Xyl',
        shortName: 'D-Xylose',
        iupacCondensed: 'Xyl',
        smiles: 'C1[C@H]([C@@H]([C@H](C(O1)O)O)O)O',
        idCode: 'deTJ@@qaeJYyzzjjjpeRy@@',
    },
];
export const iupacCondensedObject = {};
for (const sugar of sugars) {
    iupacCondensedObject[sugar.iupacCondensed] = sugar;
}
//# sourceMappingURL=sugars.js.map